import { SET_API_ERROR } from './constants'

export type ErrorRedux = {
	description: string | null,
	message: string | null,
	title: string | null
}

interface SetApiError {
	payload: ErrorRedux,
	type: typeof SET_API_ERROR
}

export const setApiError = (opts: ErrorRedux): SetApiError => ({
	type: SET_API_ERROR,
	payload: opts
})

export type Actions = SetApiError
